import DOMPurify from 'dompurify'

// Ylläpitäjien kirjoittama HTML (release notet) puhdistetaan ennen kuin se
// renderöidään dangerouslySetInnerHTML:llä. Sisältö tallennetaan sellaisenaan,
// joten ilman puhdistusta yksi ylläpitäjä voisi ajaa skriptin toisen selaimessa
// (tallennettu XSS) joko editorin tai suoran API-kutsun kautta.
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } })
}
